import React, { useEffect, useState } from 'react';

import styles from "./Login.module.css";
import { loginIcon } from "../../assets/icons/icons.ts";
import { useScreenDetector } from "../../hooks/useScreenDetector.ts";
import { Icon } from "../../ui/General/Icon/Icon.tsx";
import { LoginAndSignInPopup } from "../LoginAndSignInPopup/LoginAndSignInPopup.tsx";
// import { useMultiStorage } from '../../hooks/useStorage.ts';
import LoginSlideDownMenu from './LoginSlideDownMenu/LoginSlideDownMenu.tsx';
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store.ts';
import { setIsShowLoginAndSignInPopup } from '@/utils/storage/slices/userSlice.ts';

export const Login: React.FC = () => {
    const { isMobile, isDesktop } = useScreenDetector();
    const dispatch = useAppDispatch();
    const username = useAppSelector((state: RootState) => state.user.userInfo?.username || '');
    const [isOpen, setIsOpen] = useState(false);
    const [isSlideDownMenuOpen, setIsSlideDownMenuOpen] = useState(false);
    const isShowLoginAndSignInPopup = useAppSelector((state: RootState) => state.user.isShowLoginAndSignInPopup);
    // const [storage, setStorage] = useMultiStorage({
    //     showLoginAndSignInPopup: ['showLoginAndSignInPopup', false],
    // });

    const handleCloseLoginAndSignInPopup = () => {
        setIsOpen(false);
        dispatch(setIsShowLoginAndSignInPopup(false));
        // setStorage('showLoginAndSignInPopup', false);
    }
    useEffect(() => {
        setIsOpen(isShowLoginAndSignInPopup);
    }, []);

    /** Обработка клика на кнопку логина */
    const handleClick = () => {
        if (!username) {
            setIsOpen(true);
        } else {
            setIsSlideDownMenuOpen(true);
        }
    }

    return (<>
        <div className={styles.login} onClick={handleClick}>
            {isMobile && <Icon name='login' width={24} height={24} />}
            {isDesktop && <img src={loginIcon} alt='Логин' />}

            {username ? <div style={{ cursor: 'pointer', }}>{username}</div> : <a>Войти</a>}
            
            <LoginSlideDownMenu isOpen={isSlideDownMenuOpen} close={() => setIsSlideDownMenuOpen(false)} />
        </div>

        <LoginAndSignInPopup isOpen={isOpen} close={() => handleCloseLoginAndSignInPopup()} isHasAccount={null} isSignedIn={false} />
    </>);
}